export const pdp = {
  en: {
    // {pct} = a number. Non-breaking space between SAVE and {pct} matches the
    // literal `SAVE&nbsp;{discount}%` JSX in discountTag.tsx:23.
    savePercent: "SAVE {pct}%",
    savePercentSentenceCase: "Save {pct}%",
    // {attr} = an attribute name (e.g. "Color", "Size").
    selectAttribute: "Select {attr}:",
    // Localized attribute nouns interpolated into {attr} above. Keyed by the
    // lowercased raw attribute name from the shelf/PIM. Unknown attributes fall
    // back to the title-cased raw label (see attributeNoun in ../attributes).
    attrColor: "Color",
    attrSize: "Size",
    attrStyle: "Style",
    attrGender: "Gender",
    seeSizingChart: "See sizing chart",
    sizeChart: "Size Chart",
    shopWithConfidence: "Shop with confidence - Free exchanges",
    selectYourStyle: "Select your style",
    // Visible aria-hidden prefix before a struck-through original price.
    // Trailing space is intentional: the price follows inline.
    was: "WAS ",
    makeItYours: "Make it yours",
    addMore: "+ Add more",
    viewAllImages: "View All Images",
    noImage: "No image",
    // Visible placeholder when the main product image is missing.
    productImageFallback: "Product Image",
    // Alt text for the small pre-order clock icon.
    preOrderClockAlt: "Tiny Wee Clock",
    // {date} = a formatted date string.
    shipsSellingFast: "Ships {date} – Selling fast",
    youMightAlsoLike: "You might also like",
    from: "From",
    productNotAvailable: "Product is not available",
    loadMore: "Load More",
    loading: "Loading...",
    // Visible fallback while the promo video player initialises.
    loadingPlayer: "Loading player...",
    outOfStock: "OUT OF STOCK",
    viewMore: "View More",
    // Aria/live-region fallback when an option attribute has no selection.
    notSelected: "not selected",
    // {attr} = an attribute name. Grammar-safe fallback when an attribute has
    // no available values (DropdownOptionsSelector.tsx).
    noAttributeAvailable: "No {attr} available",
    noColorAvailable: "No Color available",
    // "Style:" label on the checkout options shelf.
    styleLabel: "Style:",
    genderMale: "Men",
    genderFemale: "Women",
    genderUnisex: "Unisex",
    genderKids: "Kids",
    selectGenderAria: "Select gender",
    // Gift-card denomination picker. {name} = the denomination label (e.g.
    // "Value"), passed by the caller.
    giftcardSelectLabel: "Select {name}:",
    giftcardValueLabel: "Value",
    giftcardEnterAmount: "Enter Amount:",
    giftcardAmountAria: "Gift card amount",
    // {symbol} = currency symbol (e.g. "$"). Placeholder + minimum-amount note.
    giftcardMinPlaceholder: "(*Min. {symbol}50)",
    giftcardMinAmount: "Minimum amount is {symbol}50",
    // Marketing tag shown on limited-edition color swatches (LP color picker).
    limitedEdition: "Limited Edition",
  },
  de: {
    savePercent: "SPARE {pct}%",
    savePercentSentenceCase: "Spare {pct}%",
    selectAttribute: "Wähle {attr}:",
    attrColor: "Farbe",
    attrSize: "Größe",
    attrStyle: "Stil",
    attrGender: "Geschlecht",
    seeSizingChart: "Größentabelle ansehen",
    sizeChart: "Größentabelle",
    shopWithConfidence: "Sicher einkaufen - Kostenloser Umtausch",
    selectYourStyle: "Wähle deinen Stil",
    was: "STATT ",
    makeItYours: "Mach es zu deinem",
    addMore: "+ Mehr hinzufügen",
    viewAllImages: "Alle Bilder ansehen",
    noImage: "Kein Bild",
    productImageFallback: "Produktbild",
    preOrderClockAlt: "Winzige kleine Uhr",
    shipsSellingFast: "Versand am {date} – wird schnell verkauft",
    youMightAlsoLike: "Das könnte dir auch gefallen",
    from: "Ab",
    productNotAvailable: "Produkt ist nicht verfügbar",
    loadMore: "Mehr laden",
    loading: "Wird geladen …",
    loadingPlayer: "Player wird geladen …",
    outOfStock: "NICHT AUF LAGER",
    viewMore: "Mehr ansehen",
    notSelected: "nicht ausgewählt",
    noAttributeAvailable: "{attr} nicht verfügbar",
    noColorAvailable: "Keine Farbe verfügbar",
    selectGenderAria: "Geschlecht auswählen",
    styleLabel: "Stil:",
    genderMale: "Herren",
    genderFemale: "Damen",
    genderUnisex: "Unisex",
    genderKids: "Kinder",
    giftcardSelectLabel: "Wähle {name}:",
    giftcardValueLabel: "Wert",
    giftcardEnterAmount: "Betrag eingeben:",
    giftcardAmountAria: "Geschenkkarten-Betrag",
    giftcardMinPlaceholder: "(*Min. {symbol}50)",
    giftcardMinAmount: "Mindestbetrag ist {symbol}50",
    limitedEdition: "Limitierte Auflage",
  },
} as const
